/**
 * check for browser support, if safari then we can't
 * support until we fix the per domain cookie size issue
 */
export enum KnownBrowsers {
    Safari,
    Edge,
    Chrome,
    Firefox,
    Opera,
    CriOS // chrome ios
}

const uaRegex = /([^\s\(]\S*[^\s\)])(\s*\([^\)]+\)\s*){0,1}\s*/g;

export function parseUserAgent(): { [browser: string] : boolean } {
    let agentString = navigator.userAgent;
    uaRegex.lastIndex = 0;
    let matches = uaRegex.exec(agentString);
    let result: { [browser: string]: boolean }= {};

    while (matches != null) {
        if (matches.length > 1) {
            let match = matches[1];
            if (match && match[0] != '(') {
                let parts = match.split('/');
                result[parts[0]] = true;
            }
        }
        matches = uaRegex.exec(agentString);
    }

    return result;
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/userAgent.ts